import type { Room } from "@prisma/client";
import { GetServerSideProps, GetServerSidePropsContext } from "next";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import React, { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import CallLoader from "~/components/calling/call-loader";

import { PageLoader } from "~/components/ui/page-loader";
import { useI18nContext } from "~/i18n/i18n-react";
import useAuthStore from "~/stores/auth";
import { api } from "~/utils/api";
import { redirectIfMobile } from "~/utils/redirect-if-mobile";

export const preloadCallLayout = () =>
	import("~/components/calling/call-layout");

const CallLayout = dynamic(preloadCallLayout, {
	loading: () => <CallLoader />,
	ssr: false,
});

const RoomIdPage = () => {
	const router = useRouter();
	const roomId = router.query.id as string;
	const [room, setRoom] = useState<Room>();
	const { LL } = useI18nContext();

	const communicationUserId = useAuthStore(
		(state) => state.user?.communicationUserId,
	);

	const { mutate } = api.room.join.useMutation({
		onSuccess: ({ room }) => {
			setRoom(room);
		},
		onError: (error) => {
			console.log("[Room] error");
			if (error) {
				toast.error(LL.SOMETHING_WENT_WRONG(), { description: error.message });
				void router.push("/");
			}
		},
	});

	const roomJoinedRef = useRef(false);
	useEffect(() => {
		const isEligbaleToJoin =
			roomId && communicationUserId && !roomJoinedRef.current;
		if (isEligbaleToJoin) {
			console.log("[Room] Joining Room", { roomId, communicationUserId });
			roomJoinedRef.current = true;
			mutate({ roomId });
		}
	}, [roomId, communicationUserId, mutate]);

	if (!room) return <PageLoader />;

	return (
		<div className="flex h-screen w-screen flex-col">
			<CallLayout room={room} />
		</div>
	);
};

export const getServerSideProps: GetServerSideProps = async (
	context: GetServerSidePropsContext,
) => {
	const redirect = redirectIfMobile(context.req);
	if (redirect) return redirect;

	return { props: {} };
};

export default RoomIdPage;
